export default __webpack_public_path__ + "static/media/eye-slash-regular.afca3ff4.svg";